import { SessionInfo, SuomiFiAuthorizationRole } from "../api/vce-api/vce-api";

interface IAuthProvider {
  isAuthenticated: boolean
  username: null | string
  hetu: null | string
  lastRefresh: number
  //personId: string|null
  companyName: string|null
  companyId: string|null
  authorizationRoles: SuomiFiAuthorizationRole[]

  setSessionInfo(session: SessionInfo): Promise<void>
  signin(username: string, hetu?: string): Promise<void>
  signout(): Promise<void>
}


const refreshTokenValidSeconds = 3600;
/**
 * This represents some generic auth provider API, like Firebase.
 */
export const AuthProvider: IAuthProvider = {
  lastRefresh: parseInt(localStorage.getItem("lastRefresh")??"0", 10),
  isAuthenticated: localStorage.getItem("username") !== null && parseInt(localStorage.getItem("lastRefresh")??"0", 10) > (new Date().getTime() / 1000 - refreshTokenValidSeconds),
  username: localStorage.getItem("username"),
  hetu: localStorage.getItem("hetu"),
  //personId: string,
  companyName: localStorage.getItem("companyName"),
  companyId: localStorage.getItem("companyId"),
  authorizationRoles: localStorage.getItem("authorizationRoles") ? JSON.parse(localStorage.getItem("authorizationRoles")!) as SuomiFiAuthorizationRole[] : [],

  async signin(username: string, hetu?: string) {
    
    AuthProvider.isAuthenticated = true;
    AuthProvider.username = username;
    AuthProvider.lastRefresh = new Date().getTime() / 1000;
    AuthProvider.hetu = hetu ?? null;

    localStorage.setItem("username", username);
    if (hetu) localStorage.setItem("hetu", hetu);
    localStorage.setItem("lastRefresh", (new Date().getTime()/1000).toString());
  },
  
  async signout() {

    AuthProvider.isAuthenticated = false;
    AuthProvider.username = "";
    AuthProvider.hetu = null;
    AuthProvider.companyName = null;
    AuthProvider.companyId = null;

    localStorage.clear();  
  },

  async setSessionInfo(session: SessionInfo) {
    
    const username = `${session.givenNames} ${session.lastname}`;
    this.signin(username, session.personId);

    const companyName = session.authorizationRoles.length > 0 ? session.authorizationRoles[0].name : "";
    const companyId = session.authorizationRoles.length > 0 ? session.authorizationRoles[0].identifier : "";

    AuthProvider.companyId = companyId;
    AuthProvider.companyName = companyName;
    AuthProvider.authorizationRoles = session.authorizationRoles;
    localStorage.setItem("company", companyName);
    localStorage.setItem("companyId", companyId);
    localStorage.setItem("authorizationRoles", JSON.stringify(session.authorizationRoles));
  }
            
};
